import { LinkButton, PrimaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { useLanguage } from "@digipost/translate";
import { FC } from "react";

import dogSniffingPackageIllustration from "../../../assets/images/illustrations/hund-snuser-pakke.svg";
import Translated from "../../infrastructure/Translated";
import { useRootPath } from "../../infrastructure/useRootPath";
import { useTranslate } from "../../infrastructure/useTranslate";
import styles from "./NotRegistered.module.css";

export const NotRegistered: FC = () => {
  const translate = useTranslate();
  const rootPath = useRootPath();
  const { language } = useLanguage();

  return (
    <div>
      <div className={styles.illustrationContainer}>
        <img
          src={dogSniffingPackageIllustration}
          alt={translate("person.not_registered.illustration_alt")}
        />
      </div>
      <Heading level={1} size="large" className={styles.heading}>
        <Translated textKey="person.not_registered.heading" />
      </Heading>

      <p className={styles.paragraph}>
        <Translated textKey="person.not_registered.register_here" />
      </p>
      <PrimaryButton
        as="a"
        href={`${rootPath}/person${window.location.search}`}
        size="large"
        className={styles.register}
      >
        <Translated textKey="person.not_registered.register_button" />
      </PrimaryButton>

      <p className={styles.paragraph}>
        <Translated
          textKey="person.not_registered.contact_customer_service"
          allowHtml={true}
        />
      </p>

      <LinkButton
        as="a"
        href={`/innlogging/${language}`}
        className={styles.backToLogin}
      >
        <Translated textKey="person.not_registered.back_to_login_private" />
      </LinkButton>
      <LinkButton
        as="a"
        href={`/innlogging/${language}/business`}
        className={styles.backToLogin}
      >
        <Translated textKey="person.not_registered.back_to_login_organisation" />
      </LinkButton>
    </div>
  );
};
